export default __webpack_public_path__ + "static/media/landing-card-1.089a086e.jpeg";